import { useContext, useMemo } from 'react';

import { useLocation } from 'react-router';

import { RegionContext } from '../contexts/RegionContextDefinition';

/**
 * Region hook with URL-based override
 *
 * URL /en prefix forces domestic mode regardless of IP:
 * - /en/* → isOverseas = false (domestic English site)
 * - /* → isOverseas from IP detection
 *
 * This ensures 3 scenarios work correctly:
 * 1. Domestic IP + no /en → Korean + Domestic products
 * 2. ANY IP + /en → English + Domestic products
 * 3. Overseas IP + no /en → English + Overseas products
 */
export const useRegion = () => {
  const context = useContext(RegionContext);
  const location = useLocation();

  if (!context) {
    throw new Error('useRegion must be used within RegionProvider');
  }

  // ✅ Override isOverseas based on URL
  // If URL has /en prefix, treat as domestic (for domestic English site)
  const isOverseas = useMemo(() => {
    if (location.pathname.startsWith('/en')) {
      return false; // Domestic English site
    }
    return context.isOverseas;
  }, [location.pathname, context.isOverseas]);

  return {
    ...context,
    isOverseas,
  };
};
